import EventEmitter from 'events/events.js'

// eslint-disable-next-line @exodus/restricted-imports/prefer-basic-utils
import lodash from 'lodash'
import proxyFreeze from 'proxy-freeze'
import { InvalidModuleError } from './errors.js'

import createLogger from './logger.js'

const { bindAll, functions } = lodash

const isFreezable = (val) => val && typeof val === 'object'

class ExodusModule extends EventEmitter {
  _name
  _logger

  constructor({ name = 'unknown', logger = createLogger(name) } = {}) {
    super()

    this._name = name
    this._logger = logger

    bindAll(this, functions(this))
  }

  emit = (name, ...args) => {
    return super.emit(name, ...args.map((arg) => (isFreezable(arg) ? proxyFreeze(arg) : arg)))
  }
}

export const validateModule = (module) => {
  const { id, dependencies } = module
  if (typeof id !== 'string') {
    throw new InvalidModuleError('expected property "id"')
  }

  if (!Array.isArray(dependencies) || dependencies.some((dep) => typeof dep !== 'string')) {
    throw new InvalidModuleError('expected property "dependencies"')
  }
}

/**
 * @deprecated Please no longer use ExodusModule. The EventEmitter functionality has been superseded by atoms and for the logging you can add a "logger" dependency which will inject a namespaced logger
 */
export default ExodusModule
